import React from 'react';
import { motion } from 'framer-motion';

const DiversityInclusion = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <section className="w-full bg-[#F1F1F1] py-16 lg:py-24 overflow-hidden select-none text-left relative z-50">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-center w-full relative"
                >

                    <motion.div
                        variants={itemVariants}
                        className="lg:col-span-6 w-full max-w-[625px] lg:max-w-none bg-[#030c22] overflow-hidden rounded-none shadow-[0_10px_30px_rgba(0,0,0,0.02)] relative z-10"
                    >
                        <img
                            src="/assets/diversity/img1.png"
                            alt="3D Abstract geometric violet and silver twisting shape artwork"
                            className="w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-104"
                        />
                    </motion.div>

                    {/* RIGHT SIDE OVERLAPPING TEXT CARD */}
                    <motion.div
                        variants={itemVariants}
                        className="max-w-full lg:absolute lg:right-0 bg-white border border-b-0 border-[#01386A45] p-8 sm:p-12 lg:p-14 flex flex-col items-start rounded-none group shadow-[0_15px_40px_rgba(0,0,0,0.06)] w-full lg:max-w-[785px] mt-6 lg:mt-0 z-20"
                    >
                        <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-10" />
                        <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#EA580C] z-20 transition-all duration-500 ease-out group-hover:w-full" />

                        <div className="w-full flex flex-col items-start relative z-30">
                            <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight leading-tight mb-5 font-sora">
                                Intentionally Diverse,<br />Globally Inclusive
                            </h2>
                            <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik">
                                We are an 'intentionally diverse and globally inclusive' organization because we believe that if you do not intentionally include, you unintentionally exclude. Being 'intentionally diverse' means that we practice inclusiveness in all aspects of diversity — from gender and sexuality to generation and ideation. Being 'globally inclusive' refers to our workforce consisting of individuals from over one hundred countries as we prioritize local talent.
                            </p>
                        </div>
                    </motion.div>

                </motion.div>

            </div>
        </section>
    );
};

export default DiversityInclusion;